import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-45faa8b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = {
  key: 0,
  class: "modal"
}
const _hoisted_6 = { class: "contenedor" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Detalles", -1))
const _hoisted_8 = { class: "contenido" }
const _hoisted_9 = { class: "contenido" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Actividad", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Detalles", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Cancelar ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "modal"
}
const _hoisted_20 = { class: "contenedor" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Detalles", -1))
const _hoisted_22 = { class: "contenido" }
const _hoisted_23 = { class: "contenido" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Actividad", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Detalles", -1))
const _hoisted_26 = { class: "alert alert-dismissible alert-success" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }),
  /*#__PURE__*/_createTextVNode(" Factura Actualizada Exitosamente! ")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Detalles de Factura", -1))
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "grid" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "No: ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Id ARS: ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ARS: ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Paciente: ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Autorización: ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha: ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Afiliado No.: ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cédula: ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Orígen: ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cobertura: ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Total: ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Actividades: ")
], -1))
const _hoisted_44 = { class: "grid-0" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "1 - Recibido por Auditoría Interna", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "2 - Verificado por Auditoría Interna", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "3 - Verificado por Auditoría Externa", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "4 - Recibido por Reclamaciones Médicas", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "5 - Verificado por Reclamaciones Médicas", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "6 - Cargado a Lote", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "7 - Enviado a la Aseguradora", -1))
const _hoisted_52 = [
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Agregar Actividad ")
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = { id: "customers" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "x"),
  /*#__PURE__*/_createElementVNode("th", null, "Actividad"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha"),
  /*#__PURE__*/_createElementVNode("th", null, "Usuario"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_58 = { class: "input-r" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (_ctx.showModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMethod())),
                          for: "btn-modal"
                        }, "X"),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", null, [
                            _hoisted_10,
                            _withDirectives(_createElementVNode("input", {
                              id: "actividad",
                              type: "actividad",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentEdition.description) = $event)),
                              class: "form-control"
                            }, null, 512), [
                              [_vModelText, _ctx.currentEdition.description]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_11,
                            _withDirectives(_createElementVNode("textarea", {
                              rows: "12",
                              id: "showInComentary",
                              type: "showInComentary",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentEdition.detalles) = $event)),
                              class: "form-control"
                            }, null, 512), [
                              [_vModelText, _ctx.currentEdition.detalles]
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-success",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.actualizar()), ["prevent"]))
                          }, _hoisted_14),
                          _hoisted_15,
                          _createElementVNode("button", {
                            class: "btn btn-danger",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.cancelar()), ["prevent"]))
                          }, _hoisted_18)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (_ctx.showModal2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("label", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (this.showModalMethod2())),
                          for: "btn-modal"
                        }, "X"),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", null, [
                            _hoisted_24,
                            _withDirectives(_createElementVNode("input", {
                              disabled: "",
                              id: "actividad",
                              type: "actividad",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentEdition.description) = $event)),
                              class: "form-control"
                            }, null, 512), [
                              [_vModelText, _ctx.currentEdition.description]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_25,
                            _withDirectives(_createElementVNode("textarea", {
                              disabled: "",
                              rows: "12",
                              id: "showInComentary",
                              type: "showInComentary",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentEdition.detalles) = $event)),
                              class: "form-control"
                            }, null, 512), [
                              [_vModelText, _ctx.currentEdition.detalles]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleAlert())),
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "alert"
            }),
            _hoisted_27
          ], 512), [
            [_vShow, _ctx.showAlert]
          ]),
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_31,
                      _createTextVNode(_toDisplayString(_ctx.facturaa.idfact), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_32,
                      _createTextVNode(_toDisplayString(_ctx.facturaa.id_ars), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_33,
                      _createTextVNode(_toDisplayString(_ctx.getARS(_ctx.facturaa.id_ars)), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_34,
                      _createTextVNode(_toDisplayString(_ctx.facturaa.nom), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_35,
                      _createTextVNode(_toDisplayString(_ctx.facturaa.nro_autorizacion_salida), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_36,
                      _createTextVNode(_toDisplayString(_ctx.formatDate2(_ctx.facturaa.fecha)) + " (" + _toDisplayString(_ctx.diffDate(_ctx.facturaa.fecha)) + " días) ", 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_37,
                      _createTextVNode(_toDisplayString(_ctx.facturaa.numero_afiliado), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_38,
                      _createTextVNode(_toDisplayString(_ctx.facturaa.rnc), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_39,
                      _createTextVNode(_toDisplayString(_ctx.facturaa.tipo_facturaa), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_40,
                      _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.facturaa.cobertura)), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_41,
                      _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.facturaa.total_servicio)), 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_42,
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    id: "estatus",
                    type: "estatus",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.facturaa.status) = $event)),
                    class: "form-select",
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeStatus()))
                  }, _hoisted_52, 544), [
                    [_vModelSelect, _ctx.facturaa.status]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "currentActivity",
                    type: "currentActivity",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentActivity) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.currentActivity]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "btn btn-success",
                    onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.addActivity()), ["prevent"]))
                  }, _hoisted_55)
                ])
              ]),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  _createElementVNode("table", _hoisted_56, [
                    _hoisted_57,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facturaa.actividad, (actividad, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_58, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", null, _toDisplayString(actividad.description), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.newFormatDate(actividad.date)), 1),
                        _createElementVNode("td", null, _toDisplayString(actividad.user), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("i", {
                            onClick: _withModifiers(($event: any) => (_ctx.deleteService(index, actividad.user)), ["prevent"]),
                            style: {"cursor":"pointer"},
                            class: "fas fa-minus-circle redOption"
                          }, null, 8, _hoisted_59),
                          _hoisted_60,
                          _createElementVNode("i", {
                            onClick: _withModifiers(($event: any) => (_ctx.editService(index, actividad)), ["prevent"]),
                            style: {"cursor":"pointer"},
                            class: "fas fa-edit greenOption"
                          }, null, 8, _hoisted_61)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _hoisted_62,
              (_ctx.showDelete)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-danger",
                    onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                  }, _hoisted_65))
                : _createCommentVNode("", true)
            ])
          ])
        ], 512), [
          [_vShow, !_ctx.cargando]
        ])
      ]),
      _: 1
    })
  ]))
}